import React, {useContext} from "react";
import {Navigate, useRoutes} from "react-router-dom";
import PrivateRoute from "./PrivateRoute";

import MainLayout from "../components/Dashboard/MainLayout";
import Dashboard from "../components/Dashboard";
import AdminDashboard from "../components/AdminDashboard";
import PricingPlan from "../components/PricingPlan";
import Invoices from "../components/Invoices";
import Settings from "../components/Settings";
import API from "../components/API";
import ForgetPassword from "../components/ForgetPassword";
import NewPasswordPage from "../components/NewPassword";
import SignUp from "../components/Signup";
import Login from "../components/Login";
import VerifyOtp from "../components/verifyOtp";
import TncAccept from "../components/TncAccept";

const RoutesList = () => {
    let element = [
        {
            path: "/",
            element: <PrivateRoute element={MainLayout}/>,
            children: [
                {path: "dashboard", element: <Dashboard/> },
                {path: "api-documentation", element: <PrivateRoute element={API}/>},
                {path: "settings", element: <PrivateRoute element={Settings}/>},
                {path: "invoices", element: <PrivateRoute element={Invoices}/>},
                {path: "pricing-plan", element: <PrivateRoute element={PricingPlan}/>},
                {path: "admin-dashboard", element: <AdminDashboard/>},
                {path: "/", element: <Navigate to="/dashboard"/>},
            ],
        },
        {path: "/login", element: <Login/>},
        {path: "tnc-accept", element: <PrivateRoute element={TncAccept}/>},
        {path: "/forget-password", element: <ForgetPassword/>},
        {path: "/verify-otp", element: <VerifyOtp/>},
        {path: "/new-password", element: <NewPasswordPage/>},
        {path: "/signup", element: <SignUp/>},
        {path: "*", element: <Navigate to="/login"/>},
    ];

    return useRoutes(element);
};

export default RoutesList;
